import React from 'react';
import { FaCar } from 'react-icons/fa';

const LoadingSpinner = ({ size = 'md', text = 'Chargement...', fullScreen = true }) => {
    const sizeClasses = {
        sm: 'h-4 w-4',
        md: 'h-8 w-8',
        lg: 'h-12 w-12',
        xl: 'h-16 w-16',
    };

    // Simple inline spinner for non-fullscreen use
    if (!fullScreen) {
        return (
            <div className="flex flex-col items-center justify-center p-4">
                <div
                    className={`${sizeClasses[size]} animate-spin rounded-full border-4 border-gray-200 border-t-primary-600`}
                />
                {text && (
                    <p className="mt-4 text-gray-600 dark:text-gray-400 text-sm">{text}</p>
                )}
            </div>
        );
    }

    // Premium full-screen loading page
    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-gradient-to-br from-gray-900 via-primary-900 to-gray-900 overflow-hidden">
            {/* Animated background particles */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute rounded-full bg-primary-500/10 animate-pulse" style={{ width: '150px', height: '150px', left: '10%', top: '20%' }} />
                <div className="absolute rounded-full bg-primary-500/10 animate-pulse" style={{ width: '100px', height: '100px', left: '80%', top: '30%', animationDelay: '1s' }} />
                <div className="absolute rounded-full bg-primary-500/10 animate-pulse" style={{ width: '120px', height: '120px', left: '60%', top: '70%', animationDelay: '0.5s' }} />
                <div className="absolute rounded-full bg-primary-500/10 animate-pulse" style={{ width: '80px', height: '80px', left: '20%', top: '80%', animationDelay: '1.5s' }} />
            </div>

            {/* Main content */}
            <div className="relative z-10 flex flex-col items-center">
                {/* Logo and brand */}
                <div className="mb-8 text-center">
                    <div className="relative inline-block">
                        {/* Glowing background */}
                        <div className="absolute inset-0 bg-gradient-to-r from-primary-500 to-green-500 rounded-full blur-xl opacity-50 animate-pulse" style={{ transform: 'scale(1.5)' }} />

                        {/* Car icon container */}
                        <div className="relative p-6 bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl shadow-2xl">
                            <FaCar className="w-16 h-16 text-white animate-bounce" style={{ animationDuration: '2s' }} />
                        </div>
                    </div>

                    {/* Brand name */}
                    <h1 className="mt-6 text-4xl font-bold text-white">
                        Car Rental
                    </h1>
                    <p className="mt-2 text-gray-400 text-sm tracking-widest uppercase">
                        Gestion de Location
                    </p>
                </div>

                {/* Loading indicator */}
                <div className="flex flex-col items-center">
                    {/* Progress bar */}
                    <div className="w-64 h-1.5 bg-gray-700 rounded-full overflow-hidden shadow-inner">
                        <div
                            className="h-full bg-gradient-to-r from-primary-500 via-green-500 to-primary-500 rounded-full animate-pulse"
                            style={{ width: '60%' }}
                        />
                    </div>

                    {/* Loading text */}
                    <div className="mt-4 flex items-center gap-2">
                        <div className="flex gap-1">
                            <span className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
                            <span className="w-2 h-2 bg-primary-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
                            <span className="w-2 h-2 bg-green-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
                        </div>
                        <span className="text-gray-400 text-sm font-medium">{text}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingSpinner;
